import { useEffect, useState } from 'react';
interface ToastProps {
  message: string;
  duration?: number;
  onClose?: () => void;
}
export const Toast: React.FC<ToastProps> = ({
  message,
  duration = 2000,
  onClose
}) => {
  const [visible, setVisible] = useState<boolean>(true);
  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
      if (onClose) onClose();
    }, duration);
    return () => clearTimeout(timer);
  }, [duration, onClose]);
  if (!visible) return null;
  return <div style={{
    width: '16rem',
    position: 'fixed',
    bottom: '50px',
    left: '50%',
    transform: 'translateX(-50%)',
    background: '#171B1F',
    color: '#fff',
    padding: '12px 24px',
    borderRadius: '25px',
    fontSize: '14px',
    boxShadow: '0 4px 10px rgba(0,0,0,0.3)',
    zIndex: 9999,
    animation: 'fadeInOut 0.3s ease-in-out'
  }} data-sentry-component="Toast" data-sentry-source-file="Toast.tsx">
      {message}

      <style>
        {`
        @keyframes fadeInOut {
          0% { opacity: 0; transform: translateX(-50%) translateY(20px); }
          100% { opacity: 0; transform: translateX(-50%) translateY(20px); }
        }
        `}
      </style>
    </div>;
};